<template>
    <Widget title="Activity Hours" :area="this.$props.area">
        <template v-if="hasData">
            <WidgetFilter :sections="{filter:'filter'}" slot="extras">
                <div slot="filter">
                    <Label text="Timezone:">
                        <el-radio v-model="show" label="utc">UTC</el-radio>
                        <el-radio v-model="show" label="local">Local</el-radio>
                    </Label>
                    <Label text="">
                        <el-checkbox v-model="peak" >Show Peak Times</el-checkbox>
                    </Label>
                </div>
            </WidgetFilter>
            <apexchart type="line" :series="series" :options="options"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";
    import * as moment from "moment";
    import WidgetFilter from "../WidgetFilter";
    import Label from "../Label";

    let times = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    export default {
        components: {NameValue, Widget, WidgetFilter, Label},
        props: {area: String},
        data() {
            return {show: 'utc', peak: false}
        },
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
            hasData() {
                return this.allPosts.length > 0;
            },
            series() {
                let data = this.allPosts.reduce((a, c) => {
                    let m = moment.unix(c.data.created_utc);
                    if (this.show === 'utc')
                        m = m.utc();

                    let hour = m.hour();
                    let date = m.format('YYYY-MM-DD');

                    if (!(a[hour])) {
                        a[hour] = {};
                    }

                    if (a[hour][date])
                        a[hour][date].push(c);
                    else
                        a[hour][date] = [c];

                    return a;
                }, {});

                let values = times.map(t => data[t] ? Object.values(data[t]).length : 0);
                return [{name: 'Activities', data: values}];
            },
            options() {

                let tzOffset = this.show === 'utc' ? 0 : new Date().getTimezoneOffset() / 60;

                let annotations = {xaxis: []};

                if (this.peak === true) {
                    annotations = {
                        xaxis: [{
                            x: this.tzTime(20, tzOffset),
                            x2: this.tzTime(22, tzOffset),
                            opacity: 0.2,
                            borderColor: '#c2c2c2',
                            label: {
                                style: {
                                    color: '#fff',
                                    background: 'rgba(50,50,250,0.3)',
                                },
                                text: 'EU Peak Hours',
                                borderColor: 'rgba(0,0,0,0)',
                            }
                        }, {
                            x: this.tzTime(10, tzOffset),
                            x2: this.tzTime(12, tzOffset),
                            opacity: 0.2,
                            label: {
                                style: {
                                    color: '#fff',
                                    background: 'rgba(50,250,50,0.3)',
                                },
                                text: 'US West Peak Hours',
                                borderColor: 'rgba(0,0,0,0)',
                            }
                        }, {
                            x: this.tzTime(13, tzOffset),
                            x2: this.tzTime(15, tzOffset),
                            opacity: 0.2,
                            label: {
                                style: {
                                    color: '#fff',
                                    background: 'rgba(250,50,50,0.3)',
                                },
                                text: 'US East Peak Hours',
                                borderColor: 'rgba(0,240,0,0)',
                            }
                        }],
                    };
                }
                return {
                    chart: {
                        foreColor: '#ccc',
                        events: {
                            dataPointSelection: (a, b, c) => {
                                this.props.showData(
                                    Object.values(data[c.dataPointIndex]).reduce((a, c) => a.concat(c), []),
                                    `Posts between ${c.dataPointIndex}:00 and ${c.dataPointIndex + 1}:00`
                                )
                            }
                        },
                        zoom: {
                            enabled: false
                        }

                    },
                    colors: ['#fc0'],
                    xaxis: {
                        categories: times,
                        labels: {
                            formatter: (value, timestamp, index) => {
                                return value + ':00'
                            }
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                    },
                    annotations
                }
            }
        },
        methods: {
            open() {
            },
            tzTime(time, offset) {
                return time - offset < 0 ? 24 - offset : time - offset;
            },
            updateOptions() {
            },
            created() {
                // this.updateOptions();
            },
            updated() {
                // this.updateOptions();
            }
        }
    }
</script>

<style scoped>

</style>

